import { Component, OnInit } from '@angular/core';
import { ItemService } from '../item/item.service';
import { HttpParams } from '@angular/common/http';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTransferModule, TransferItem } from 'ng-zorro-antd/transfer';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { ItemPriceService } from './item-price.service';
import { LoadingService } from 'src/app/share/services/loading.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-item-price',
  imports: [NzIconModule, NzTransferModule, CommonModule, FormsModule, NzButtonModule],
  templateUrl: './item-price.component.html',
  styleUrl: './item-price.component.scss'
})
export class ItemPriceComponent implements OnInit {
  items: any[];
  targetKeys: any[] = [];
  constructor(private itemService: ItemService, private service: ItemPriceService, private loadingService: LoadingService, private router: Router) {

  }
  ngOnInit(): void {
    let params = new HttpParams()
      .set('page', "-1")
      .set('pageSize', "-1");
    this.itemService.getItems(params).subscribe({
      next: x => {
        const ret: Array<TransferItem & { id: string; name: string; price: number; mm_category: string, mm_metric: string, category: string, metric: string, status: string; icon: string,itemcategory_id:string,itemmetric_id:string}> = [];
        x.data.forEach((x: any) => {
          ret.push({
            key: x.id,
            id: x.id,
            title: x.name,
            name: x.name,
            price: x.price,
            category: x.itemcategory?.name,
            metric: x.itemmetric?.name,
            mm_category: x.itemcategory?.mm_name,
            mm_metric: x.itemmetric?.mm_name,
            status: x.status,
            itemcategory_id:x.itemcategory_id,
            itemmetric_id:x.itemmetric_id ,
            icon: this.getIcon(x.status)
          });
        });
        this.items = ret;
      },
      error: err => { },
      complete: () => {

      }
    });
  }
  select(ret: {}): void {
    console.log('nzSelectChange', ret);
  }

  change(ret: {}): void {
    console.log('nzChange', ret);
  }

  getIcon(status: number): string {
    let icon = '';
    switch (status) {
      case 1: icon = "minus-square";
        break;
      case 2: icon = "up-circle";
        break;
      case 3: icon = "down-circle";
        break;
      default: icon = "minus-square";
        break;
    }
    return icon;
  }
  submit() {
    this.loadingService.showLoading();
    this.service.createItem({ items: this.items.filter(x => x.direction == "right"), unpublished_items: this.items.filter(x => x.direction == "right") })
      .subscribe({
        next: (x) => { this.loadingService.hideLoading(); },
        error: (errr: any) => { this.loadingService.hideLoading(); },
        complete: () => { this.router.navigate(['/item']); }
      });
  }
}
